<template>
  <div
    class="messenger-person"
    @click.prevent="showClientPopup = true"
  >
    <div class="messenger-person__avatar">
      <div class="messenger-person-avatar">
        <vx-tooltip
          v-if="currentClient.profile_image_url"
          :text="currentClient.name"
        >
          <vs-avatar
            :src="currentClient.profile_image_url"
            :text="currentClient.name"
            size="40px"
            style="margin: 0"
          />
        </vx-tooltip>
      </div>
    </div>
    <div class="messenger-person__info">
      <div class="messenger-person-contacts">
        <div class="messenger-person-contacts__name">{{ currentClient.name }}</div>
        <div class="messenger-person-contacts__phone">{{ currentClient.phone }}</div>
      </div>
      <vx-tooltip
        v-if="currentClient.description && currentClient.description.length > 40"
        :text="currentClient.description"
      >
        <div class="messenger-person-comment">
          {{ currentClient.description }}
        </div>
      </vx-tooltip>
      <div
        v-else
        class="messenger-person-comment"
      >
        {{ currentClient.description }}
      </div>
    </div>
    <person-popup
      v-if="showClientPopup"
      @close="showClientPopup = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PersonPopup from './PersonPopup.vue'

export default {
  components: {
    PersonPopup
  },

  data () {
    return {
      showClientPopup: false
    }
  },

  computed: mapGetters(['currentClient'])
}
</script>
